import { render } from "./RestaurantMenuType.vue?vue&type=template&id=5d74f2d0&scoped=true"
import script from "./RestaurantMenuType.vue?vue&type=script&lang=js"
export * from "./RestaurantMenuType.vue?vue&type=script&lang=js"

import "./RestaurantMenuType.vue?vue&type=style&index=0&id=5d74f2d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d74f2d0"]])

export default __exports__